import * as React from 'react';

import Glyph from 'components/Glyph';
import Menu from 'components/Menu';
import MenuButton from 'components/MenuButtonDeprecated';
import ModalMenuItem from 'components/ModalMenuItem';
// @ts-ignore
import GroupRemoveFromOrgModal from 'groups/components/GroupRemoveFromOrgModal';
import { ClassProfile_classes } from 'groups/queries/__generated__/ClassProfile';

type Props = {
  group: ClassProfile_classes;
  onRemoveGroupFromOrg: () => void;
  openModalRemoveGroupFromOrgEventKey: string;
};

export default class GroupActionsMenuButton extends React.Component<Props> {
  renderMenuItems = () => {
    const { group, openModalRemoveGroupFromOrgEventKey, onRemoveGroupFromOrg } = this.props;
    const { permissions, organization } = group;

    if (!permissions || !organization) {
      return [];
    }

    if (!permissions.can_remove_from_org) {
      return [];
    }

    return [
      <ModalMenuItem
        menuKey="open-modal"
        eventKey={openModalRemoveGroupFromOrgEventKey}
        modal={
          <GroupRemoveFromOrgModal group={group} onRemoveGroupFromOrg={onRemoveGroupFromOrg} />
        }>
        <Glyph name="close" />
        <span>Remove from {organization.name}</span>
      </ModalMenuItem>,
    ];
  };

  render() {
    const items = this.renderMenuItems();
    if (items.length === 0) {
      return null;
    }

    return (
      <MenuButton
        alignment="right"
        level="secondary"
        size="small"
        menu={<Menu>{items}</Menu>}
        tooltip="More actions"
        tooltipPlacement="top">
        <Glyph name="ellipses" size="inherit" solo />
      </MenuButton>
    );
  }
}
